<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="100px"
    >
      <el-form-item label="备注">
        <el-input v-model="remark" />
      </el-form-item>
      <el-form-item label="小程序链接">
        <el-input v-model="mini_program_url" />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbitr"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { oceancopyv2urlcreate } from '@/api/massiveAdvertising/accountList.js'
export default {
  components: {},
  data() {
    return {
      labelPosition: 'right',
      remark: '',
      mini_program_url: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    sumbitr() {
      // eslint-disable-next-line eqeqeq
      if (this.remark == '') {
        this.$message.error('请输入备注')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.mini_program_url == '') {
        this.$message.error('请输入小程序链接')
        return
      }
      oceancopyv2urlcreate({
        remark: this.remark,
        mini_program_url: this.mini_program_url
      }).then(res => {
        console.log('res', res)
        this.$emit('updata')
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
